import React from "react"
import { Redirect } from "@reach/router";

function Careers(){
    return <Redirect noThrow to="careers/Artist/" />;
}

export default Careers